"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

import { heroDefaultValues } from "../HeroV2/HeroV2.builder";

export const heroContainerInputs = [
  {
    name: "isContainerWidth",
    type: "boolean",
    defaultValue: false,
  },
  {
    name: "isViewportHeight",
    type: "boolean",
    defaultValue: true,
  },
  {
    name: "mobileMediaAtTop",
    type: "boolean",
    defaultValue: false,
  },
  {
    name: "autoplayEnabled",
    friendlyName: "Autoplay enabled",
    type: "boolean",
    defaultValue: false,
  },
  {
    name: "autoplayDelay",
    friendlyName: "Autoplay delay interval",
    type: "string",
    enum: ["3", "4", "5", "6", "7", "8", "9", "10"],
    defaultValue: "5",
  },
  {
    name: "breadcrumbsSpacing",
    type: "boolean",
    defaultValue: false,
  },
  {
    name: "childBlocks",
    type: "uiBlocks",
    onChange: (options: Map<string, unknown>) => {
      const items = options.get("childBlocks");

      if (Array.isArray(items)) {
        const allChildrenAreHero = items.every((item) => item.component?.name === "Hero");

        const filteredItems = items.filter((item) => item.component?.name === "Hero");

        if (!allChildrenAreHero) {
          options.set("childBlocks", filteredItems.slice(0, 3));
          alert("Only Hero Container related components are allowed");
        }
      }
      if (Array.isArray(items) && items.length > 3) {
        options.set("childBlocks", items.slice(0, 3));
        alert("Only 3 Hero components are allowed");
      }
    },
    defaultValue: [
      {
        "@type": "@builder.io/sdk:Element",
        component: {
          name: "Hero",
          options: {
            data: heroDefaultValues,
          },
        },
      },
    ],
  },
] as const satisfies Inputs;

export const HeroBannerContainerComponent: RegisteredComponent = {
  name: "HeroBannerContainer",
  friendlyName: "HeroBannerContainer (new)",
  component: dynamic(async () =>
    withValidation(
      heroContainerInputs,
      (await import("./HeroBannerContainer")).HeroBannerContainer,
      "HeroBannerContainer"
    )
  ),
  shouldReceiveBuilderProps: {
    builderBlock: true,
  },
  canHaveChildren: true,
  childRequirements: {
    message: "Only Hero Container related components are allowed",
    query: {
      "component.name": {
        $in: ["Hero"],
      },
    },
  },
  inputs: heroContainerInputs,
};
